import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  MaxLengthValidator,
  ValidationErrors,
  ValidatorFn,
  Validators
} from '@angular/forms';

import { NgbAccordion } from '@ng-bootstrap/ng-bootstrap';

import { AlertService } from "../../../_services/alert.service";

import { environment } from "../../../../environments/environment";

import { ApiHttpService } from "../../../_services/api-http.service";
import {
  ColDef,
  FilterChangedEvent,
  FilterModifiedEvent,
  FilterOpenedEvent,
  GridApi,
  GridReadyEvent,
  ICellRendererParams,
  PaginationChangedEvent,
  RowClickedEvent,
} from 'ag-grid-community';
import { MerchantService } from '../merchants/merchant-master/merchant.service';
import { lastValueFrom } from 'rxjs';


const { API_URL } = environment;
interface DropDownValues {
  FieldValue: number,
  FieldText: string
}


@Component({
  selector: 'app-negative-merchant',
  templateUrl: './negative-merchant.component.html',
  styleUrls: ['./negative-merchant.component.scss']
})
export class NegativeMerchantComponent implements OnInit {

  orvreport: FormGroup;
  form: FormGroup;
  Resultdata: any;
  merchantId:any;
  pageSize: number = 10;
  private filterObj: any = {};
  SingleRow: any;
  currentPage: number = 0;
  collectionSize: number = 0;
  merchantdis: boolean = true;
  filedis: boolean = true;
  public quickFilterShow: boolean = false;
  selectedFile:any;
  loading: boolean = false;
  merchantID:any=""
  legalName:any=""
  public searchMID: string ;
  public searchMerName:string;
  bussinesstype:any=""
  bussinessCategory:any=""
  subBussinessCategory:any=""
  riskScore:any=""
  public page: number = 1
  
  collectiondata: number=0
  private specialKeys: Array<string> = [
    "Backspace",
    "Tab",
    "End",
    "Home",
    "-",
    "ArrowLeft",
    "ArrowRight",
    "Del",
    "Delete"
  ];
  @ViewChild('acc') private acc: NgbAccordion;
  private gridApi!: GridApi;

  public deleterowData: any[] = [
    // Add more rows here as needed...
  ];
  public businessTypeOptions: DropDownValues[];

  // public rowData: any[];

  public rowData: any[] = [
    // Add more rows here as needed...
  ];
  public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 150,
    filter: false,
    resizable: true
  };
  public columnDefs: ColDef[] = [
    { field: 'id', headerName: 'ID', hide: true },
    { field: 'legalName', tooltipField: 'sp_id', headerName: 'Legal Name'},
    { field: 'merchantId', tooltipField: 'sp_id', headerName: 'Merchant ID'},
    { field: "tradeName", tooltipField: 'sp_id', headerName: 'trade Name' },
    { field: 'contactPerson', tooltipField: 'sp_id', headerName: 'Contact Person'},
    { field: "contactNo", tooltipField: 'sp_id', headerName: 'Contact No' },
    { field: "emailId", tooltipField: 'sp_id', headerName: 'Email Id' },
    { field: "createdOn", tooltipField: 'sp_id', headerName: 'Created On' },
    { field: "kycApproval", tooltipField: 'sp_id', headerName: 'KYC approval' },
    { field: "status", tooltipField: 'sp_id', headerName: 'STATUS' },  
  ];


  tableSelectedColumn: ColDef[] = [...this.columnDefs]; 
  constructor(private  formBuilder: FormBuilder, private apiHttpService: ApiHttpService,private alertService: AlertService, private merchantService: MerchantService) {

    this.orvreport = formBuilder.group({
      merchantId: ["", Validators.required],
      fileupload:["",Validators.required],
    }) 
  }
  async ngOnInit(): Promise<void> {
      let merchantdata = { "name": "" }
    this.apiHttpService
      .post(`${API_URL}/GetMerchantnegative/`, merchantdata)
      .subscribe((res) => {
        this.Resultdata = res
      });
      const businessType$ = this.merchantService.getBusinessType();
      this.businessTypeOptions = await lastValueFrom(businessType$);
      this.getBusinessCatigory();
    }
    MerchnatList() {
      let reqData = {
        "name": ""
      }
      console.log("request body", reqData)
      this.merchantService.getMerchantBYName(reqData).subscribe((res:any) => {
          this.Resultdata = res
          console.log("merchant mid",res)
        });
    }
    categoryTypeOptions:any;
    getBusinessCatigory(){
      debugger
      this.merchantService.getCategoryType().subscribe((data)=>{
       this.categoryTypeOptions=data;     
        console.log("response=="+JSON.stringify(data))
       // alert("response=="+JSON.stringify(data))
        console.log("data=="+data)
      })
    }
    onselectBusinessType(event:any){
      //alert(event)
        if(event==undefined){
           this.bussinesstype=""             
        }
      else{
        this.bussinesstype=event;           
        }       
      }
      onselectBusinessCat(event:any){
        if(event==undefined){   
           this.bussinessCategory=""
           this.subBussinessCategory="" 
           this.searchMID="" 
           this.subCategoryTypeOptions=[]      
         }
      else{        
        this.bussinessCategory=event;          
          this.getBusinessSubCatigory();
        }       
      }
      subCategoryTypeOptions:any;
      getBusinessSubCatigory(){     
          debugger
        this.merchantService.getSubCategoryType(this.bussinessCategory).subscribe((data)=>{
        this.subCategoryTypeOptions=data;
          console.log("subCategoryTypeOptions=="+JSON.stringify(this.subCategoryTypeOptions))
          console.log("subCategoryTypeOptions=="+this.subCategoryTypeOptions)
        })
    
      }
      onselectBusinessSubCat(event:any){
        if(event==undefined){         
           this.subBussinessCategory=""         
        }
      else{
        this.subBussinessCategory=event;           
        }        
      }

    quickFilterShowAction($event: Event) {
      this.quickFilterShow = !this.quickFilterShow
      if (!this.quickFilterShow) {     
        // this.categorysearch.handleClearClick();
        // this.subCategorySearch.handleClearClick();
        // this.risksearch.handleClearClick();  
        // this.searchFromDate = '';
        // this.searchToDate = '';
       // this.refreshGrid();
      }
    }
    allowAlfanumeric($event: Event): void {
      if(this.searchMID.length>10)
      {
        return
      }
  
      this.searchMerName = this.searchMerName.replace(/[^a-z 0-9]/gi,'')||'';
      this.searchMID = this.searchMID.replace(/[^a-z 0-9]/gi,'')||'';
    }

    ondata(data:any){

      debugger
      this.loading = false
      return this.apiHttpService
      .post(
        `${API_URL}/docs/findDocs/${data}/OSV?pageSize=10&page=1`, null
      )
      .subscribe((data) => {
        this.collectionSize = data.totalElements;
        this.rowData = (data.content?.data|| Array.isArray(data.content) ? data.content : []).map((d: any) => {
           return {
            ...d,
          }
        })
      });
    
    }

    onMerchantSearch(event:Event){
      this.merchantdis=true;
      if(event){
        this.ondata(event);
      }else{
        this.reloadonGridReady();
      }
    }

    file:any;
    onFileSelected(event: Event): void {

      this.filedis=true;
      const inputElement = event.target as HTMLInputElement;
      if (inputElement.files && inputElement.files.length > 0) {
        this.selectedFile = inputElement.files[0];
      }
    }

    


    onSubmit(formvalue: any): void {
     if(formvalue.merchantId&&formvalue.fileupload){

      this.filedis=true;
          this.merchantdis=true;
      const formData = new FormData();
      formData.append('imageFile', this.selectedFile);  
      formData.append('merchantId',  this.merchantId || formvalue.merchantId,);
      formData.append('type',"OSV" );
      this.apiHttpService
          .post(
           `${API_URL}/docs/upload`,
            //`${API_URL}/docs/upload`,
            formData  
          ).subscribe((data) => {
            document?.getElementById('loading')?.classList.remove("spinner-border")
            document?.getElementById('loading')?.classList.remove("spinner-border-sm");            
            if (!data?.null) {
              if(data.responseCode=="1111"){
              this.alertService.successAlert( "File Upload Successfully!");
             this.reloadonGridReady();
             this.orvreport.reset();
            }else if(data.responseCode=="0000"){
                this.alertService.successAlert( "File Upload  Updated Successfully!");
                this.reloadonGridReady();
                this.orvreport.reset();
           }
              else{
                this.alertService.errorAlert({text:"File upload fail.!"})
              }
            }
          }, (error) => {
            console.log("Error------>", error);
          });
        }
        else{
         if(! formvalue.merchantId){
            this.merchantdis=false;
         }
         if(!  formvalue.fileupload){
          this.filedis=false;
         }         
        }
    }
  
   
searchbypayid(event:any){
  //alert(event)
  if(event==undefined){ 
    this.legalName ="" 
    this.merchantID=""
    //this.getSummaryReportData(); 
  }
else{
  this.merchantID=event; 
  this.merchantID=event;  
   // this.getSummaryReportData();   
  }  
}
searchbyMerchantName(event:any){
  //alert(event)
  if(event==undefined){ 
    this.legalName ="" 
   
   
  }
else{
  this.legalName=event; 
 
  }  
}

    
    onGridReady(params: GridReadyEvent<any>) {

      this.filedis=true;
      this.merchantdis=true;
      debugger
      this.loading = false
      return this.apiHttpService
      .post(
        `${API_URL}/merchants`, null
      )
      .subscribe((data) => {
        this.collectionSize = data.length        ;
        this.rowData = (data?.data|| Array.isArray(data) ? data : []).map((d: any) => {
           return {
            ...d,
          }
        })
      });
    }
    getNegativeMerchantReport(){
      this.merchantService.getNegativeReportData(this.riskScore,this.merchantID,this.bussinessCategory,this.subBussinessCategory,this.bussinesstype,this.legalName,this.pageSize,this.page).subscribe((data)=>{   
        //console.log("getSummaryReportDatarowData=="+JSON.stringify(data?.merchantsSummery));
        // this.rowData = data?.content  || data || [],
        this.rowData = data?.negativeMerchantDtos  || data || [],   
        this.collectiondata = data?.totalRecords||0          
        this.collectionSize=this.collectiondata;
        if(this.collectiondata <=0){
         // this.alertService.errorAlertWithMessage("No records present");
          this.rowData=[];
          return }
      }
      )
    }




    reloadonGridReady(){

      this.filedis=true;
      this.merchantdis=true;
      debugger
      this.loading = false
      return this.apiHttpService
      .post(
        `${API_URL}/docs/fetchDocs/${this.pageSize}/${this.currentPage}?type=OSV`, null
      )
      .subscribe((data) => {
        this.collectionSize = data.totalElements;
        this.rowData = (data.content?.data|| Array.isArray(data.content) ? data.content : []).map((d: any) => {
          return {
            ...d,
          }
        })
      });
    }
    onFilterOpened(param: FilterOpenedEvent | any) {
      console.log("onFilterOpened----->", param);
    }
    onFilterModified(param: FilterModifiedEvent | any) {
      debugger
      const temp = param?.filterInstance;
      this.filterObj[param?.column?.colId] = temp;
    }
    onRowDoubleClicked(param: RowClickedEvent | any) {
      debugger
      let coldata=param.data;
     let merchant=coldata.merchantId;
      this.apiHttpService
      .post(
        `${API_URL}/docs/download/${coldata.merchantId}/OSV`, null
        )
      .subscribe((data) => (
       this.downloadPdf(data,merchant)
      ));
      param.node.setExpanded(!param.node.expanded);
    }
    downloadPdf(data:any,merchantdata:any) {
      const linkSource =
      'data:application/octet-stream;base64,' +data.text;
      const downloadLink = document.createElement('a');
      const fileName = merchantdata+'_OSV.pdf';
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
    }
    async onRowClicked(param: RowClickedEvent | any) {
      this.SingleRow = param.data
    }
   
    

      onPaginationChange(param: PaginationChangedEvent | any) {
        this.page=param;
       // alert(this.page)
        debugger
        this.rowData=[]
        // this.gridApi.applyTransaction({remove: this.rowData})
        //  this.gridApi.showLoadingOverlay();   
        this.getNegativeMerchantReport();   
      }
      onPageSizeChanges($event: Event) {
        debugger
        // this.gridApi.paginationSetPageSize(this.pageSize)
        // this.gridApi.applyTransaction({remove: this.rowData})
        // this.gridApi.showLoadingOverlay();
       this.rowData=[]
    this.getNegativeMerchantReport();
      }


    }